import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Stock_Moving_Dist from './Stock_Moving_Dist';

const Stock_Moving_Int = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; 
    const currentYear = currentDate.getFullYear();

    const [month, setMonth] = useState(currentMonth);
    const [year, setYear] = useState(currentYear);
    const [stockStatus, setStockStatus] = useState('');
    const [statusList, setStatusList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState(null);

    // Load stock status list on mount
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_URL}/api/stock/status`)
            .then(res => setStatusList(res.data))
            .catch(err => console.error("Error loading stock statuses:", err));
    }, []);

    const months = Array.from({ length: 12 }, (_, i) => (
        <option key={i + 1} value={i + 1}>
            {new Date(0, i).toLocaleString('default', { month: 'long' })}
        </option>
    ));

    const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

    // In handleSubmit()
const handleSubmit = () => {
    if (!stockStatus) {
        alert("Please select a Stock Status.");
        return;
    }
    if (!month || !year) {
        alert("Please select Month and Year.");
        return;
    }
    setLoading(true);
    setContent(<Stock_Moving_Dist month={month} year={year} stock_status={stockStatus} />);
    setLoading(false);
};

    return (
        <div style={{ textAlign: 'center', margin: '20px' }}>
            <table style={{ margin: '0 auto', borderCollapse: 'collapse' }}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={6} className="p-2 text-lg">Stock Update Details</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Month</td>
                        <td>
                            <select value={month} onChange={e => setMonth(Number(e.target.value))}>
                                {months}
                            </select>
                        </td>
                        <td>Year</td>
                        <td>
                            <select value={year} onChange={e => setYear(Number(e.target.value))}>
                                {years.map(y => <option key={y} value={y}>{y}</option>)}
                            </select>
                        </td>
                        <td>Stock Status</td>
                        <td>
                            <select
                                value={stockStatus}
                                onChange={e => setStockStatus(e.target.value)}
                            >
                                <option value="" disabled>Select</option>
                                {statusList.map(s => (
                                    <option key={s} value={s}>{s}</option>
                                ))}
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="6" style={{ textAlign: 'center' }}>
                            <button onClick={handleSubmit} className="tableheader" style={{ margin: '5px' }}>
                                Submit
                            </button>
                            <button onClick={() => window.history.back()} className="tableheader" style={{ margin: '5px' }}>
                                Back
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            {loading && <div><img src="src/images/progress.gif" alt="loading" /></div>}
            {content}
        </div>
    );
};

export default Stock_Moving_Int;
